import { Stack, Typography } from '@mui/material';

export const ItemWithLabel = ({ label, value }: { label?: string; value?: React.ReactNode }) => {
  return (
    <Stack>
      <Typography variant='caption'>{label || ''}</Typography>
      {typeof value === 'string' ? (
        <Typography variant='subtitle2'>{value || '-'}</Typography>
      ) : (
        value
      )}
    </Stack>
  )
}
